import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const DiwaliGifts = () => {
    const CTAContent = [
        {
          pageName: "Diwali Gifts",
          paragraphitalic: "Light Up Every Moment",
          paragraphText:
                "Celebrate the festival of lights with gifts that illuminate relationships and bring smiles. From traditional sweets to modern gadgets, our Diwali gifting options blend tradition with contemporary charm.",
          ContactFormName: "Diwali Gifts",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Traditional Diyas & Puja Kits",
          parapgraphItalic: " Light Up Traditions, Brighten Every Celebration!",
          sectionparagraphText: (
            <>
              <p>
                Make the festive spirit with timeless diyas and complete puja essentials. 
              </p>
              <p>
                Celebrate the essence of festivals with our carefully curated collection of traditional diyas and puja kits. Crafted to add radiance and serenity to your rituals, these timeless pieces are perfect for both personal use and thoughtful gifting. Each item is designed to blend tradition with elegance, ensuring a truly divine experience.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/diwali-gifts/Traditional Diyas & Puja Kits.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Gourmet Sweet Boxes",
          parapgraphItalic: "Indulge in the Sweet Side of Festivities!",
          sectionparagraphText: (
            <>
              <p>
                From traditional Flavors to modern delights, our gourmet sweets redefine indulgence.
              </p>
              <p>
                This festive season, let your gifts be remembered for their taste and charm. Our gourmet sweet boxes combine traditional recipes with a modern twist, offering an unmatched culinary experience. Perfect for clients, employees, and loved ones, these beautifully packaged treats add sweetness to every celebration.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/diwali-gifts/Gourmet Sweet Boxes.jpg",
          categoryHeadingLeftSide: "Features that Delight",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/diwali-gifts/Curated Selection.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Curated Selection</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/diwali-gifts/Premium Packaging.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Premium Packaging</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/diwali-gifts/Custom Branding.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Custom Branding</b> <br></br>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/diwali-gifts/Features that Illuminate.jpg",
          NogapHeading: "Features that Illuminate",
          Heading: [
            {
              ListHeading: "Handcrafted Diyas",
              ListParagraph:
                " Beautifully designed in clay, brass, and other premium materials for that authentic touch.",
            },
            {
              ListHeading: "Complete Puja Kits",
              ListParagraph:
                "Everything you need for rituals, from incense sticks to kalash and kumkum, all in one elegant package.",
            },
            {
              ListHeading: "Customizable Options",
              ListParagraph:
                "Add your brand logo or a special message for a personal touch.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/diwali-gifts/Exclusive Home Décor Items.jpg",
          NogapHeading: "Exclusive Home Décor Items",
          paragraphItalic: "Transform Spaces, Celebrate in Style! ",
          paragraphDetail: (
            <>
              <p>
                Elegant home décor pieces to enhance every festive moment.
              </p>
              <p>
                This festive season, gift more than just décor—gift memories. Our exclusive home décor items are designed to add beauty and elegance to any space, making them perfect for celebrations or everyday luxury. Whether it’s ornate candleholders or artistic wall hangings, each piece exudes style and sophistication.
              </p>
            </>
          ),
    
          NogapSubheading: "Features that Impress",
          Categories: [
            {
              ServiceImg: "../assests/images/diwali-gifts/Artisanal Designs.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Artisanal Designs</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/diwali-gifts/Wide Range of Options.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Wide Range of Options</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/diwali-gifts/Custom Personalization.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Custom Personalization</b>
                  </p>
                </>
              ),
            },
          ],
        },
    
        /**new index */
        {
          RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
          NogapHeading: "Milestone Recognition ",
          paragraphItalic: "Make sure every gift reflects excellence.",
          paragraphDetail: (
            <>
              <p>Appreciate dedication and achievements.</p>
              <p>
                Show appreciation for the hard work and dedication that goes into
                every achievement.
              </p>
              <p>
                Milestones such as work anniversaries, project completions, and
                promotions deserve to be celebrated. At eYantra, we provide a range
                of premium milestone gifts that are as unique as the achievements.
              </p>
            </>
          ),
    
          NogapSubheading: "Our Milestone Gift Options Include:",
          Categories: [
            {
              ServiceImg: "../assests/images/sub-pages/logo-printing.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Personalized Awards</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/engraving.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/color-matching.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>
          Diwali Gifts
        </title>
        </Helmet>
        <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Let your Diwali gifts speak volumes about your appreciation and goodwill. 
      </p>
    </>
  );
};

export default DiwaliGifts;
